import React from 'react';

const Aim = () => {
	return (
		<div>
			<h1>AIM</h1>
		</div>
	);
};

export default Aim;
